// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import OptionsDropDown from '../../../shared/components/options-drop-down';

const DemoRentalHistoryBranchCriteria = props =>
    <div className='demo-rental-branch-criteria'>
        <OptionsDropDown
            className='demo-rental-branch'
            isPlaceholderTranslated={false}
            label='BRANCH'
            onChange={props.onBranchChange}
            optionDisplayAttributes={['value']}
            optionKey='key'
            options={props.branches}
            placeholder='SELECT_BRANCH'
            selectedValue={props.branch}
        />
    </div>;

DemoRentalHistoryBranchCriteria.displayName = 'DemoRentalHistoryBranchCriteria';
DemoRentalHistoryBranchCriteria.propTypes = {
    branch: PropTypes.string.isRequired,
    branches: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    onBranchChange: PropTypes.func.isRequired
};

export default DemoRentalHistoryBranchCriteria;



// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/components/demo-rental-history-branch-criteria.js